import React from 'react';
import type { Scene } from '../types/scene';
import './SceneInfo.css';

interface SceneInfoProps {
  scene: Scene | null;
  currentTime: number;
  className?: string;
}

const SceneInfo: React.FC<SceneInfoProps> = ({ scene, className = '' }) => {

  if (!scene) {
    return null;
  }

  return (
    <div className={`scene-info ${className}`}>
      <div className="scene-info-content">
        <div className="scene-title-container">
          <div className="scene-title">{scene.title}</div>
          {scene.urls && scene.urls.length > 0 && (
            <a 
              href={scene.urls[0]} 
              target="_blank" 
              rel="noopener noreferrer"
              className="external-link-icon scene-info-link"
              onClick={(e) => e.stopPropagation()}
              aria-label={`Visit external link for ${scene.title}`}
            >
              🔗
            </a>
          )}
        </div>
        <div className="scene-description">{scene.description}</div>
      </div>
    </div>
  );
};

export default SceneInfo;